import React from "react";
import { Link } from "react-router-dom";

interface PageLinkButtonProps {
  path: string;
  text?: string;
}

const PageLinkButton: React.FC<PageLinkButtonProps> = ({ path, text }) => (
  <Link
    to={path}
    className="text-black bg-white font-normal text-base border-0 outline-none rounded-none border-b border-black p-0 pb-0.5 no-underline hover:cursor-pointer disabled:text-gray-400 disabled:border-b-gray-400 disabled:cursor-auto text-left"
  >
    {text || "See More"}
  </Link>
);

export { PageLinkButton };
